import React from 'react';
import { processSteps } from '../../data/mock';

const ProcessSection = () => {
  return (
    <section className="section-padding bg-[#111111]">
      <div className="container-luxury">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="heading-luxury mb-6">
            Как <span className="gradient-text">работим</span>
          </h2>
          <p className="text-lg text-[#A9A9A9] leading-relaxed">
            Прозрачен и структуриран процес от първия контакт до успешното финализиране
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {processSteps.map((step, index) => (
              <div 
                key={index}
                className="relative"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Step Card */}
                <div className="relative bg-[#0B0B0B] border border-[#D4AF37]/10 rounded-lg p-8 hover:border-[#D4AF37] transition-all duration-300 group">
                  {/* Step Number */}
                  <div className="absolute -top-6 left-8 w-12 h-12 bg-gradient-to-br from-[#F3D98B] to-[#D4AF37] rounded-full flex items-center justify-center shadow-lg shadow-[#D4AF37]/20 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-[#0B0B0B] font-bold text-lg">
                      {step.number}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="mt-8">
                    <h3 className="text-xl font-serif font-semibold text-[#F6F2E8] mb-4">
                      {step.title}
                    </h3>
                    <p className="text-[#A9A9A9] text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Connector Arrow - Mobile */}
                {index < processSteps.length - 1 && (
                  <div className="lg:hidden flex justify-center py-4">
                    <div className="w-0.5 h-8 bg-gradient-to-b from-[#D4AF37]/30 to-transparent"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
